import React, { useState } from "react";
import {
  Flex,
  Text,
  Box,
  Image,
  Button,
  VStack,
  HStack,
  PinInput,
  PinInputField,
  useToast,
  Spinner,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

import logo from "../../assets/logo.png";
import kidsImage from "../../assets/register-image-kids.png";
import useOtpVerify from "api/mutations/useOtpVerify";

const Otp = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const [otp, setOtp] = useState("");

  const otpVerifyMutation = useOtpVerify({
    onSuccess: (res) => {
      if (res?.status === 200) {
        setOtp("");
        toast({
          title: "OTP verified successfully!",
          description: "You can now reset your password.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        navigate("/reset-password", {
          state: {
            token: res?.data?.token,
          },
        });
      }
    },
    onError: (err) => {
      const response = err.response;
      setOtp("");
      toast({
        title: "Something went wrong.",
        description: response?.data?.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    },
  });

  // ✅ Submit Handler
  const handleContinue = () => {
    try {
      const data = {
        email: localStorage.getItem("email"),
        otp: otp,
        role: "seller",
      };
      otpVerifyMutation.mutate(data);
    } catch (e) {
      toast({
        title: "Something went wrong",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <Flex
      justify="center"
      align="center"
      height="100vh"
      bg="white"
      border="1px solid #2a4567"
      position="relative"
      boxShadow="0px 4px 20px rgba(0, 0, 0, 0.25)"
    >
      {/* Left Content */}
      <Box
        flex={1}
        justifyContent="center"
        alignItems="center"
        display={"flex"}
      >
        <VStack align="flex-center" spacing={7} width={400}>
          <Image src={logo} width={"425px"} height={"100px"} />
          <Text
            fontFamily={"PlusJakartaSansMedium"}
            fontSize={"36px"}
            lineHeight={"38px"}
            color={"#000000"}
            textAlign={"center"}
          >
            Verify Your Email
          </Text>
          {/* <Text
            fontFamily={"PlusJakartaSansRegular"}
            fontSize={"16px"}
            lineHeight={"28px"}
            textAlign={"center"}
            color={"#898989"}
          >
            we’ve sent a code to johndoe@xyz.com
          </Text> */}
          <HStack spacing="8" justifyContent="center" alignItems="center">
            <PinInput otp onChange={setOtp} placeholder="" size="md">
              {Array.from({ length: 4 }).map((_, index) => (
                <PinInputField
                  key={index}
                  w="64px"
                  h="64px"
                  borderRadius="8px"
                  border="1px solid #D9D9D9"
                  bg={"#f9f9f9"}
                  boxShadow="sm"
                  _hover={{ borderColor: "#F0F0F0" }}
                  _focus={{
                    borderColor: "#3182CE",
                    boxShadow: "0 0 0 1px #F0F0F0",
                  }}
                />
              ))}
            </PinInput>
          </HStack>
          <Flex justifyContent={"center"} alignItems={"center"} gap={1}>
            <Text
              fontFamily={"PlusJakartaSansRegular"}
              fontSize={"12px"}
              lineHeight={"18px"}
              color={"#000000"}
            >
              Didn’t get an email?
            </Text>
            <Text
              fontFamily={"PlusJakartaSansRegular"}
              fontSize={"12px"}
              lineHeight={"18px"}
              color={"#456EFF"}
              cursor={"pointer"}
              textDecoration={"underline"}
              onClick={() => {}}
            >
              Resend Verification
            </Text>
          </Flex>
          <VStack>
            <Button
              bgColor={"#456EFF"}
              colorScheme="#456EFF"
              borderRadius={"12px"}
              fontFamily={"PlusJakartaSansSemiBold"}
              fontSize={"16px"}
              lineHeight={"20px"}
              color={"#FFFFFF"}
              textAlign={"center"}
              w={"100%"}
              h={"48px"}
              onClick={() => handleContinue()}
              isDisabled={otp.length !== 4}
              _hover={{
                bg: "#456EFF",
                color: "#FFFFFF",
              }}
            >
              {otpVerifyMutation.isLoading ? <Spinner /> : "Continue"}
            </Button>
          </VStack>
        </VStack>
      </Box>
      {/* Right Image */}
      <Box flex={1}>
        <Image
          src={kidsImage}
          alt="Kids Fashion"
          objectFit="cover"
          width={589}
          height={440}
        />
      </Box>
    </Flex>
  );
};

export default Otp;
